import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'apollo-react/components/Button';
import styles from './SectionApprovalButton.module.css';

/**
 * SectionApprovalButton - Button component for approving/unapproving form sections
 *
 * Displays "Approve Section" when not approved, "Undo Section Approval" when approved.
 * Only visible to reviewers who can take action on the form.
 *
 * @param {Object} props
 * @param {boolean} props.isApproved - Whether the section is currently approved
 * @param {Function} props.onApprove - Callback to approve the section
 * @param {Function} props.onUndoApprove - Callback to undo approval
 * @param {boolean} props.disabled - Whether the button is disabled
 * @param {boolean} props.loading - Whether an action is in progress
 */
const SectionApprovalButton = ({
  isApproved,
  onApprove,
  onUndoApprove,
  disabled = false,
  loading = false,
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (isApproved) {
      onUndoApprove?.();
    } else {
      onApprove?.();
    }
  };

  return (
    <Button
      variant={isApproved ? 'secondary' : 'primary'}
      onClick={handleClick}
      disabled={disabled || loading}
      fullWidth
      className={styles.sectionApprovalButton}
    >
      {loading
        ? t('processing')
        : isApproved
          ? t('undoSectionApproval')
          : t('approveSection')}
    </Button>
  );
};

export default SectionApprovalButton;
